import React from 'react';
import { Link } from "react-router-dom";
import { Auth } from 'aws-amplify';
import * as MESSAGES from '../Lib/Messages';
import Logo from './Logo';
import Notification from './Notification';
import InputError from './InputError';
import Validator from '../Lib/Validator';

class UserResetPass extends React.Component {
	constructor(props) {
		super();
		this.state = {
				user: {
					email: '',
					password: '',
          code: ''
				},
				errors: {},
        isError: false,
			  message: null
		};

		this.handleChange = this.handleChange.bind(this);
		this.clearForm = this.clearForm.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		const { user, errors } = this.state;
		user[name] = value;
		if(errors[name]) {
			delete errors[name];
		}
		this.setState(user);
	}

	clearForm() {
		var obj = {
		user: {
			email: '',
			password: '',
			code: ''
		}
		};

		this.setState(obj);
	}

	isValidation() {
		const { user } = this.state;
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;
		var validator = new Validator();
		if(!validator.required(user.email)) {
			errors['email'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if(!validator.email(user.email)) {
			errors['email'] = MESSAGES.ERROR_EMAIL;
			isError = true;
		}
		if(!validator.required(user.code)) {
			errors['code'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		}
		if(!validator.required(user.password)) {
			errors['password'] = MESSAGES.ERROR_REQUIRED;
			isError = true;
		} else if(!validator.minLength(user.password, 8)) {
			errors['password'] = MESSAGES.ERROR_MINLENGTH;
			isError = true;
		}
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		if(isError) {
			this.setState({ errors });
			return false;
		}

		return true;
	}

	handleSave = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		const { user } = this.state;
    	Auth.forgotPasswordSubmit(user.email, user.code, user.password)
        .then(data => {
          this.clearForm();
          this.setState({errorMessage: MESSAGES.SUCCESS_RESET_PASSWORD, isError: false});
        })
        .catch(err => {
        	if(err.message) {
				this.setState({errorMessage: err.message, isError: true});
			}
        });
	}

	render() {
		const { user, errors, isError, errorMessage } = this.state;
		return (
			<div className="center-sign">
				<Logo />
				<div className="panel card-sign">
					<div className="card-title-sign mt-3 text-right">
						<h2 className="title text-uppercase font-weight-bold m-0"><i className="fa fa-user mr-1"></i> Reset Password</h2>
					</div>
					<div className="card-body">
						<form action="/" method="POST">
							<Notification isError={isError} message={errorMessage} isPublic="true" />
							<div className={`form-group mb-3 ${errors.email ? 'has-danger' : null}`}>
								<label>Email</label>
								<div className="input-group input-group-icon">
									<input
					                      name="email" type="email"
					                      className="form-control form-control-lg"
					                      value={user.email}
					                      onChange={this.handleChange}
					                      validations={['required', 'email']}
					                  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-user"></i>
										</span>
									</span>
								</div>
								<InputError error={errors.email} />
							</div>

							<div className={`form-group mb-3 ${errors.code ? 'has-danger' : null}`}>
				                <label className="float-left">Your Verification Code</label>
								<div className="input-group input-group-icon">
									<input
					                      name="code" type="text"
					                      className="form-control form-control-lg"
					                      value={user.code}
					                      onChange={this.handleChange}
					                      validations={['required']}
					                  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-barcode"></i>
										</span>
									</span>
								</div>
								{errors.code ? (<label className="error">{errors.code}</label>) : (null)}
							</div>

							<div className={`form-group mb-3 ${errors.password ? 'has-danger' : null}`}>
                				<label className="float-left">New Password</label>
								<div className="input-group input-group-icon">
									<input
					                      name="password" type="password"
					                      className="form-control form-control-lg"
					                      value={user.password}
					                      onChange={this.handleChange}
					                      validations={['required']}
					                  />
									<span className="input-group-addon">
										<span className="icon icon-lg">
											<i className="fa fa-lock"></i>
										</span>
									</span>
								</div>
								{errors.password ? (<label className="error">{errors.password}</label>) : (null)}
							</div>

							<div className="row">
								<div className="col-sm-8">
								</div>
								<div className="col-sm-4 text-right">
									<button type="submit" className="btn btn-primary mt-2" onClick={this.handleSave}>Confirm</button>
								</div>
							</div>
							<br />

              				<p className="text-center mt-3">Remembered? <Link role="menuitem" tabIndex="-1" to="/user/signin">Sign In!</Link></p>
						</form>
					</div>
				</div>

				<p className="text-center text-muted mt-3 mb-3">&copy; Copyright 2018. All Rights Reserved.</p>
			</div>
		)
	}
}

export default UserResetPass;
